import { html, ViewTemplate, when, repeat } from '@microsoft/fast-element';
import { getHtmlIconByName } from '../../../../styles';
import type { SellerTile } from './seller-tile';
import { sync } from '@genesislcap/foundation-utils';

export const SellerTileTemplate: ViewTemplate<SellerTile> = html`
  <div class="card-styles">
    ${when(
      (x) => !x.project,
      html<SellerTile>`
        <div class="tile-info-div">
          <div class="tile-all-projects-title-div">
            <span class="tile-all-projects-title">All Project Statistics</span>
          </div>
          <div class="tile-elements-div">
            <div class="col">
              <div class="row">
                <zero-slider
                  value="${sync((x) => x.projectSliderValue)}"
                  min="0"
                  max="100"
                  readonly
                >
                  <span slot="thumb" id ="all-projects-percentage">${sync((x) => x.projectSliderValue)}%</span>
                    <zero-tooltip anchor="all-projects-percentage" position="right">
                        Percentage of all project’s capacity currently under contract.
                        ${(x) => x.getExecutedFractionText(x.projectsExecutedVolume, x.projectsAvailableCapacity)}
                    </zero-tooltip>
                </zero-slider>
              </div>
              <div class="row">
                ${repeat(
                  (x) => x.allProjectsSummary,
                  html`
                    <tile-card :title=${(x) => x?.title} :tooltip=${(x) => x?.tooltip} inline>
                      ${repeat(
                        (x) => x.items,
                        html`
                          <span>${(x) => x.value}</span>
                        `,
                      )}
                    </tile-card>
                  `,
                )}
              </div>
            </div>
            <div class="col">
              <div class="row">
                ${repeat(
                  (x) => x.allProjectsContracts,
                  html`
                    <tile-card :title=${(x) => x?.title}>
                      ${repeat(
                        (x) => x.items,
                        html`
                          <span>${(x) => x.value}</span>
                        `,
                      )}
                    </tile-card>
                  `,
                )}
              </div>
            </div>
          </div>
        </div>
      `,
    )}
    ${when(
      (x) => x.project,
      html<SellerTile>`
        <div class="tile-info-div">
          <div class="tile-title-div">
            <span class="tile-title" @click=${(x) => x.openIndividualProjectPage()}>
              ${(x) => x.data?.title}
            </span>
            <span class="tile-sub-title">${(x) => x.data?.subTitle}</span>
          </div>
          <div class="tile-elements-div">
            <div class="col">
              <div class="row">
                <zero-slider
                  value="${(x) => x.getScrollbarValue(x.executedVolume, x.availableCapacity)}"
                  min="0"
                  max="100"
                  readonly
                >
                  <span slot="thumb" id="project-percentage">
                    ${(x) => x.getScrollbarValue(x.executedVolume, x.availableCapacity)}%
                  </span>
                    <zero-tooltip anchor="project-percentage" position="right">
                        Percentage of this project’s capacity currently under contract.  
                        ${(x) => x.getExecutedFractionText(x.executedVolume, x.availableCapacity)}
                    </zero-tooltip>
                    
                </zero-slider>
              </div>
              <div class="row">
                ${repeat(
                  (x) => x.data.inventoryProgress,
                  html`
                    <tile-card :title=${(x) => x?.title} :tooltip=${(x) => x?.tooltip} inline>
                      ${repeat(
                        (x) => x.items,
                        html`
                          ${when(
                            (x) => x.icon,
                            html`
                              <span>${(x) => getHtmlIconByName(x.icon)}</span>
                            `,
                          )}
                          <span>${(x) => x.value}</span>
                        `,
                      )}
                    </tile-card>
                  `,
                )}
              </div>
            </div>
            <div class="col">
              <div class="row">
                ${repeat(
                  (x) => x.data.valuesList,
                  html`
                    <tile-card :title=${(x) => x?.title}>
                      ${repeat(
                        (x) => x.items,
                        html`
                          ${when(
                            (x) => x.icon,
                            html`
                              <span>${(x) => getHtmlIconByName(x.icon)}</span>
                            `,
                          )}
                          <span>${(x) => x.value}</span>
                        `,
                      )}
                    </tile-card>
                  `,
                )}
              </div>
            </div>
          </div>
          <div class="buttons-slot">
            <slot name="buttons"></slot>
          </div>
        </div>
      `,
    )}
  </div>
`;
